export default <T>(list: T[] | undefined): T | undefined =>
  list ? list[0] : undefined;
